<app-detail [name]="name"
            [id]="id"
            [apiController]="apiController"
            [views]="views"
            viewType="compressed"
            [toolbarItems]="toolbarItems"
            [keyFieldName]="keyFieldName"
            [preSave]="true"
            (save)="preSave($event)"
            (entityLoaded)="entityLoaded()"
            [(entity)]="entity"
            [showRemoveButton]="canUpdateBundles"
            [showSaveButton]="canUpdateBundles">

</app-detail>
